jQuery(document).ready(function($) {

	$.navigation = {
		init: function() {
			$.navigation.events();
		},

		events: function() {
			var oDocument = $(document);

			oDocument.on('click', '.m-navigation-opener, .m-navigation-opener > span', function(e) {
				e.stopPropagation();
				e.preventDefault();

				var oNavigation = $('.l-navigation');
				oNavigation.toggleClass('active');
				oNavigation.css('z-index', '30');
			});

			oDocument.on('click', function(e) {
				if (!$(e.target).hasClass('l-navigation') && !$(e.target).parents('.l-navigation').length > 0) {
					var oNavigation = $('.l-navigation');
					oNavigation.removeClass('active');
				}
			});

			oDocument.on('click', '.m-navigation__item.menu-item-has-children > .m-navigation__link', function(e) {
				e.stopPropagation();
				e.preventDefault();

				$(this).parent().toggleClass('active');
			});

			oDocument.on('click', '.m-nav-search-form__submit', function(e) {
				var form = $('.m-nav-search-form form');
				var input = $('.m-nav-search-form input');

				if (input.val() !== "") {
					form.submit();
				}
			});

		},

		adjustNavigationHeight: function() {
			var iDefaultHeight = $('.m-navigation__inner').outerHeight();
			var iListHeight = $('.m-navigation__list-wrapper', '.m-navigation__item.active').outerHeight();
			var iNewHeight = iDefaultHeight;

			if (iDefaultHeight < iListHeight) {
				iNewHeight = iListHeight;
			} else {
				iNewHeight = iDefaultHeight;
			}

			$('.l-navigation').css('max-height', iNewHeight);
		}
	};

});